import React, { PureComponent } from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import messages from './messages';
import css from './index.scss';
import AssignCourseMapper from '../assign-course-mapper-admin';
import withLoader from '../with-loader';
import ViewCourseModal from './modal/view-course';
import EmptyState from '../empty-state/index';
import { StudentManagement } from '../../helpers/icon-dictionary';

class ManageAssignCourse extends PureComponent {
    getDefaultObject = () => {
        const { classrooms, yearGroups, isYearGroupDataLoaded, isClassroomDataLoaded } = this.props;

        if (isYearGroupDataLoaded && isClassroomDataLoaded) {
            for (const year of yearGroups) {
                const classroom = classrooms.find(item => item.yearGroupEnum === year.yearGroupEnum);
                if (classroom) {
                    const group = classroom.classroomGroups[0];
                    return {
                        DefaultYear: year.yearGroupEnum,
                        DefaultClassroom: classroom.classroomId,
                        DefaultGroup: group.id
                    };
                }
            }
        }

        return -1;
    }
    render() {
        const { intl,
            classrooms,
            courseDetails,
            yearGroups,
            isYearGroupDataLoaded,
            isClassroomDataLoaded,
            isCourseModalVisible,
            handleOnAssign,
            assignedTasksId,
            showAssignErrorModal,
            showSaveErrorModal,
            assigningCourses,
            activateModal,
            handleOnSaveAssignCourses,
            isAssignEvent,
            dispatch,
            selectedProduct } = this.props;

        let pageContent = null;

        if (isYearGroupDataLoaded && isClassroomDataLoaded) {
            if (classrooms.length) {
                pageContent = (<AssignCourseMapper
                    activateModal={activateModal}
                    assignedTasksId={assignedTasksId}
                    assigningCourses={assigningCourses}
                    classrooms={classrooms}
                    defaultCourses={this.props.defaultCourses}
                    defaultData={this.getDefaultObject()}
                    dispatch={dispatch}
                    handleOnAssign={handleOnAssign}
                    handleOnSaveAssignCourses={handleOnSaveAssignCourses}
                    isAssignEvent={isAssignEvent}
                    selectedProduct={selectedProduct}
                    showAssignErrorModal={showAssignErrorModal}
                    showSaveErrorModal={showSaveErrorModal}
                    upfCourseId={this.props.upfCourseId}
                    yearGroups={yearGroups}
                />);
            } else {
                pageContent = (<div className={css.emptyState}><EmptyState
                    iconName={StudentManagement}
                    message={intl.formatMessage(messages.emptyStateMessage)} /></div>);
            }
        } else {
            pageContent = (<div />);
        }


        return (<div>
            <div className={css.header}>
                <div className={css.mainHeading}>
                    <div className={css.title}>{intl.formatMessage(messages.pageTitle)}</div>
                </div>
                <div className={css.subHeading}>
                    <span> {intl.formatMessage(messages.pageSubTitle)} </span>
                </div>
            </div>
            {pageContent}
            <ViewCourseModal
                courseDetails={courseDetails}
                handleOnViewCourse={this.props.handleOnViewCourse}
                hideCourseDetails={this.props.hideCourseDetails}
                show={isCourseModalVisible} />
        </div>);
    }
}

ManageAssignCourse.propTypes = {
    intl: intlShape.isRequired,
    isYearGroupDataLoaded: PropTypes.bool,
    isClassroomDataLoaded: PropTypes.bool,
    isCourseModalVisible: PropTypes.bool,
    classrooms: PropTypes.arrayOf(PropTypes.object),
    courseDetails: PropTypes.object,
    yearGroups: PropTypes.array,
    handleOnAssign: PropTypes.func,
    handleOnSaveAssignCourses: PropTypes.func,
    assignedTasksId: PropTypes.array,
    upfCourseId: PropTypes.number,
    showAssignErrorModal: PropTypes.bool,
    showSaveErrorModal: PropTypes.bool,
    activateModal: PropTypes.bool,
    assigningCourses: PropTypes.bool,
    isAssignEvent: PropTypes.bool,
    dispatch: PropTypes.func.isRequired,
    handleOnViewCourse: PropTypes.func,
    hideCourseDetails: PropTypes.func.isRequired,
    defaultCourses: PropTypes.object,
    selectedProduct: PropTypes.object
};

const DefaultCourseWithDataLoader = withLoader('fetching')(ManageAssignCourse);
export default injectIntl(styleable(css)(DefaultCourseWithDataLoader));



// WEBPACK FOOTER //
// ./app/components/manage-assigned-course/manage-assigned-course.js